module.exports = __webpack_public_path__ + "img/AFMS_DRIGHT_CLOSE.941b335f.png";